module.exports = __webpack_public_path__ + "img/navigate.527e01d0.png";